module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 11 21",
      url: __webpack_public_path__ + "img/icons.0a12b861.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }